export const am = {
  "nav.check_booking": "ቦታ ማስያዝ ይመልከቱ",
  "nav.admin": "አስተዳዳሪ",
  "nav.book_now": "አሁን ያስይዙ",
  "nav.driver": "ሹፌር",
  "hero.badge": "የJ1 ቪዛ ተማሪዎች ትራንስፖርት",
  "hero.title": "ቀላል ትራንስፖርት",
  "hero.subtitle": "ከቺካጎ አውሮፕላን ማረፊያዎች ወደ ዊስኮንሲን የሚታመን ጉዞዎ",
  "hero.description": "ለJ1 ቪዛ ተማሪዎች ደህንነቱ የተጠበቀ፣ አስተማማኝ እና ተመጣጣኝ ትራንስፖርት። የአውሮፕላን ማረፊያ ፒክአፕ ወይም የመመለሻ ጉዞዎን ዛሬ ያስይዙ!",
  "hero.book_trip": "ጉዞዎን ያስይዙ",
  "hero.check_status": "የቦታ ማስያዝ ሁኔታ ይመልከቱ",
  "pricing.title": "የትራንስፖርት ዋጋ",
  "pricing.subtitle": "ሁሉም ዋጋዎች በዩኤስ ዶላር",
  "pricing.ohare_mke": "ፒክ አፕ (O'Hare / Milwaukee)",
  "pricing.midway": "ፒክ አፕ (Midway)",
  "pricing.madison": "ማዲሰን ወደ ዊስኮንሲን ዴልስ",
  "pricing.return": "የመመለሻ ቅናሽ",
  "pricing.shared": "የጋራ ጉዞ",
  "pricing.private": "የግል ጉዞ",
  "pricing.per_person": "በሰው",
  "pricing.after_deposit": "ከ$20 ቅድመ ክፍያ በኋላ",
  "pricing.without_deposit": "ያለ ቅድመ ክፍያ",
  "pricing.flat_rate": "ቋሚ ዋጋ",
  "pricing.per_suitcase": "በሻንጣ",
  "pricing.carry_on": "የእጅ ሻንጣ",
  "pricing.free": "ነፃ",
  "pricing.with_shipping": "ተመላሽ + ከእኛ ጋር ላክ",
  "pricing.special_deal": "ልዩ ቅናሽ!",
  "pricing.midway_contact": "ለMidway (MDW) ዋጋዎች ያግኙን",
  "pricing.waterpark_note": "ዋጋዎች ለThree Bears Water Park ወይም ሌሎች መድረሻዎች ሊለያዩ ይችላሉ።",
  "pricing.contact_us": "ያግኙን",
  "pricing.guidelines_title": "ዋጋችን እንዴት ይሰራል",
  "pricing.guidelines_deposit": "በሰው $20 ቅድመ ክፍያ ቦታዎን ያስጠብቃል። ቀሪው ሚዛን በጉዞ ቀን ይከፈላል።",
  "pricing.guidelines_shared": "በተመሳሳይ ቀን ወደ ተመሳሳይ አውሮፕላን ማረፊያ የሚጓዙ 2 ወይም ከዚያ በላይ ተሳፋሪዎች የጋራ ጉዞ ዋጋ ያገኛሉ።",
  "pricing.guidelines_solo": "ብቸኛ ተሳፋሪዎች (በዚያ ቀን ብቻ ተሳፋሪ) ትንሽ ከፍ ያለ ዋጋ ሊከፍሉ ይችላሉ።",
  "pricing.guidelines_suitcase": "1 ሻንጣ ለመመለሻ ጉዞዎች ነፃ ነው። እያንዳንዱ ተጨማሪ ሻንጣ $5 ነው።",
  "pricing.guidelines_payment": "ካርድ፣ ጥሬ ገንዘብ እና Zelle ክፍያዎችን እንቀበላለን።",
  "requirements.title": "የቦታ ማስያዝ መስፈርቶች",
  "requirements.pickup": "በ24 ሰዓታት ውስጥ ሁለት ጊዜ ፒክአፕ እናቀርባለን ካልተነገረን በቀር። አስቀድመው ያቅዱ!",
  "requirements.deposit": "ወደ መርሃ ግብሩ ከመጨመርዎ በፊት ተመላሽ የማይሆን $20 USD ቅድመ ክፍያ ያስፈልጋል።",
  "requirements.seamless": "ማንኛውንም መዘግየት ለማስወገድ ቅድመ ክፍያዎን አስቀድመው በመፈጸም ቦታዎን ያስጠብቁ።",
  "requirements.final_payment": "ቀሪው ሚዛን ወደ ተሽከርካሪው ከመግባትዎ በፊት ይከፈላል።",
  "special.title": "መድረሻ በዝርዝሩ ውስጥ የለም?",
  "special.description": "ከመደበኛ መንገዶቻችን ውጪ ወደ መድረሻዎች ልዩ ጥያቄ ጉዞዎችን እናቀርባለን። ለብጁ ዋጋ ያግኙን!",
  "special.call": "ይደውሉ",
  "special.whatsapp": "WhatsApp ያድርጉ",
  "features.title": "ቀላል ትራንስፖርትን ለምን ይመርጣሉ?",
  "features.subtitle": "በየበጋው በሺዎች የJ1 ተማሪዎች የሚታመን",
  "features.easy_booking": "ቀላል ቦታ ማስያዝ",
  "features.easy_booking_desc": "$20 USD ቅድመ ክፍያ ብቻ ያስፈልጋል። በባንክ ዝውውር፣ ካርድ፣ PayPal ወይም Zelle ይክፈሉ።",
  "features.safe": "ደህንነቱ የተጠበቀ እና አስተማማኝ",
  "features.safe_desc": "ሙያዊ ሹፌሮች፣ ምቹ ተሽከርካሪዎች እና ለJ1 ተማሪዎች 24/7 ድጋፍ።",
  "features.flexible": "ተለዋዋጭ መርሃ ግብ",
  "features.flexible_desc": "የመድረሻ እና የመመለሻ ጉዞዎችን ያስይዙ። የመጀመሪያ ሻንጣ በመመለሻ ነፃ!",
  "video.badge": "በተግባር ይመልከቱን",
  "video.title": "ጉዞዎ ከዚህ ይጀምራል",
  "video.subtitle": "የJ1 ተማሪዎችን ጀብዳቸውን ሲጀምሩ ይመልከቱ",
  "video.book_now": "ጉዞዎን አሁን ያስይዙ",
  "booking.title": "ጉዞዎን ያስይዙ",
  "booking.step": "ደረጃ",
  "booking.of": "ከ",
  "booking.trip_type": "የጉዞ ዓይነት",
  "booking.arrival": "መድረስ (የአውሮፕላን ማረፊያ ፒክአፕ)",
  "booking.return": "መመለስ (ወደ አውሮፕላን ማረፊያ)",
  "booking.ride_type": "የጉዞ ዓይነት",
  "booking.shared_ride": "የጋራ ጉዞ",
  "booking.shared_desc": "በተመሳሳይ መንገድ ላይ ከሌሎች ተሳፋሪዎች ጋር ያጋሩ",
  "booking.private_ride": "የግል ጉዞ",
  "booking.private_desc": "ለእርስዎ ብቻ የተለየ ተሽከርካሪ",
  "booking.pickup_location": "የፒክአፕ አውሮፕላን ማረፊያ",
  "booking.select_airport": "አውሮፕላን ማረፊያ ይምረጡ",
  "booking.travel_date": "የጉዞ ቀን",
  "booking.travel_time": "የሚጠበቀው የመድረስ ሰዓት",
  "booking.departure_time": "የመነሻ ሰዓት",
  "booking.flight_number": "የበረራ ቁጥር",
  "booking.airline": "አየር መንገድ",
  "booking.terminal": "የመድረሻ ተርሚናል",
  "booking.full_name": "ሙሉ ስም",
  "booking.whatsapp": "የWhatsApp ቁጥር",
  "booking.email": "የኢሜል አድራሻ",
  "booking.housing": "የመኖሪያ ቤት",
  "booking.select_housing": "መኖሪያ ይምረጡ",
  "booking.custom_address": "ብጁ አድራሻ ያስገቡ",
  "booking.num_passengers": "የተሳፋሪዎች ብዛት",
  "booking.suitcases": "ጠቅላላ ሻንጣዎች",
  "booking.shipping": "የT&M Courier አገልግሎት ይጠቀማሉ?",
  "booking.payment": "የክፍያ ዘዴ",
  "booking.referral": "የሪፈራል ኮድ",
  "booking.next": "ቀጣይ",
  "booking.previous": "ቀዳሚ",
  "booking.submit": "ቦታ ማስያዝ ያጠናቅቁ",
  "booking.processing": "በመስራት ላይ...",
  "booking.start_over": "እንደገና ይጀምሩ",
  "booking.first_time": "የመጀመሪያ ጉዞ",
  "booking.returning": "የሚመለስ ደንበኛ",
  "booking.confirmation_number": "የማረጋገጫ ቁጥር",
  "pricing_summary.title": "የዋጋ ማጠቃለያ",
  "pricing_summary.trip_price": "የጉዞ ዋጋ",
  "pricing_summary.luggage_fee": "የሻንጣ ክፍያ",
  "pricing_summary.deposit": "ቅድመ ክፍያ",
  "pricing_summary.per_person": "በሰው",
  "pricing_summary.discount": "የሪፈራል ቅናሽ",
  "pricing_summary.total_now": "አሁን የሚከፈል ጠቅላላ",
  "pricing_summary.balance": "ቀሪ ሚዛን",
  "success.title": "ቦታ ማስያዝ ተረጋግጧል!",
  "success.confirmation": "የማረጋገጫ ቁጥር",
  "success.details": "የቦታ ማስያዝ ዝርዝሮች",
  "success.whatsapp_optin": "በWhatsApp ዝመናዎችን ያግኙ",
  "success.home": "ወደ መነሻ ተመለስ",
  "driver.title": "የሹፌር ዳሽቦርድ",
  "driver.login": "የሹፌር መግቢያ",
  "driver.phone": "ስልክ ቁጥር",
  "driver.pin": "የPIN ኮድ",
  "driver.sign_in": "ይግቡ",
  "driver.trips_today": "የዛሬ ጉዞዎች",
  "driver.upcoming": "መጪ ጉዞዎች",
  "driver.passengers": "ተሳፋሪዎች",
  "driver.suitcases": "ሻንጣዎች",
  "driver.navigate": "ወደ ፒክአፕ ይጓዙ",
  "driver.contact": "ተሳፋሪን ያግኙ",
  "driver.complete": "ጉዞ ያጠናቅቁ",
  "driver.logout": "ውጣ",
  "driver.no_trips": "ምንም የታቀዱ ጉዞዎች የሉም",
  "common.loading": "በመጫን ላይ...",
  "common.error": "የሆነ ስህተት ተፈጥሯል",
  "common.save": "ያስቀምጡ",
  "common.cancel": "ሰርዝ",
  "common.close": "ዝጋ",
  "common.details": "ዝርዝሮች",
  "common.status": "ሁኔታ",
  "common.date": "ቀን",
  "common.time": "ሰዓት",
  "common.price": "ዋጋ",
  "common.passenger": "ተሳፋሪ",
  "common.passengers": "ተሳፋሪዎች",
};
